import React from "react";
import { cn } from "./utils";

export default function TableToolbar({ children, className = "" }) {
  return (
    <div className={cn("mb-3 flex flex-wrap items-end gap-3 border-b border-slate-200 pb-3", className)}>
      {children}
    </div>
  );
}
